import Layout from "components/Layout";
import React from "react";
import Card from "./Card";
import { Grid } from "@chakra-ui/react";
import cards from "./Cards";

const Home = () => {
  return <Layout>
	<Grid 
		w="full"
		templateColumns={{lg: 'repeat(3, 1fr)', md: 'repeat(2, 1fr)', sm: 'repeat(1, 1fr)'}}
		gap={6}
	>
		{
			cards.map(card => <Card key={card.title} {...card} />)
		}
	</Grid>
  </Layout>
};

export default Home;
